module.exports = __webpack_public_path__ + "static/media/Thumbs.27f7a3c4.db";